module.exports = __webpack_public_path__ + "img/ic-message.f321d93c.svg";